import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalModule} from 'ng2-bootstrap/modal';

import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalAddQuestionComponent} from './modal-add-question.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    FormsModule,
    SearchBarModule,
  ],
  declarations: [
    ModalAddQuestionComponent,
  ],
  exports: [
    ModalAddQuestionComponent,
  ],
})
export class ModalAddQuestionModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-add-question/modal-add-question.module.ts